import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Route ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px overflow-y-auto pb-16" }
const _hoisted_8 = { class: "py-3 flex flex-col w-3/4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Route", -1)
const _hoisted_10 = { class: "py-3 flex flex-col w-3/4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Lokasi Awal", -1)
const _hoisted_12 = { class: "py-3 flex flex-col w-3/4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Destinasi", -1)
const _hoisted_14 = { class: "py-3 flex flex-row w-3/4" }
const _hoisted_15 = { class: "w-1/2 mr-4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Route Code", -1)
const _hoisted_17 = { class: "w-1/2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe Route", -1)
const _hoisted_19 = { class: "flex flex-col border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Route "),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md text-12px" }, " Klik tombol dibawah untuk mengaktifkan rute. Anda dapat mengubah status kapan saja. ")
], -1)
const _hoisted_21 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_22 = { class: "ml-4" }
const _hoisted_23 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_24 = { class: "py-3" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Route ", -1)
const _hoisted_26 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "capitalize" }
const _hoisted_29 = { class: "py-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_31 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_32 = { class: "text-gray-lp-500" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Terakhir Diubah ", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_36 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_RouteOptionsSection = _resolveComponent("RouteOptionsSection")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              (!_ctx.isError)
                ? (_openBlock(), _createBlock(_component_button_fill, {
                    key: 0,
                    title: "Simpan",
                    onClick: _ctx.onOpenSave,
                    class: "px-8 bg-red-lp-300"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("textarea", {
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 w-full resize-none ${
                _ctx.isDisabled ? 'bg-white text-gray-lp-600' : 'text-black-lp-300'
              }`
            ,
                      rows: _ctx.detailData.route_name.length > 55 ? 2 : 1,
                      value: _ctx.detailData.route_name,
                      disabled: _ctx.isDisabled
                    }, "\n          ", 10, ["rows", "value", "disabled"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("input", {
                      type: "text",
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 w-full ${
                _ctx.isDisabled ? 'bg-white text-gray-lp-600' : 'text-black-lp-300'
              }`
            ,
                      disabled: _ctx.isDisabled,
                      value: _ctx.detailData.origin_location
                    }, null, 10, ["disabled", "value"])
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("input", {
                      type: "text",
                      class: 
              `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 w-full ${
                _ctx.isDisabled ? 'bg-white text-gray-lp-600' : 'text-black-lp-300'
              }`
            ,
                      disabled: _ctx.isDisabled,
                      value: _ctx.detailData.destination
                    }, null, 10, ["disabled", "value"])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode("input", {
                        type: "text",
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 w-full ${
                  _ctx.isDisabled ? 'bg-white text-gray-lp-600' : 'text-black-lp-300'
                }`
              ,
                        disabled: _ctx.isDisabled,
                        value: _ctx.detailData.route_code
                      }, null, 10, ["disabled", "value"])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("input", {
                        type: "text",
                        class: 
                `py-1.5 xxl:py-3 px-4 rounded border border-gray-lp-400 focus:outline-none focus:shadow my-1 w-full ${
                  _ctx.isDisabled ? 'bg-white text-gray-lp-600' : 'text-black-lp-300'
                }`
              ,
                        disabled: _ctx.isDisabled,
                        value: _ctx.typeRoute(_ctx.detailData.route_type)
                      }, null, 10, ["disabled", "value"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode("div", _hoisted_21, [
                      _createVNode(_component_Toggle, {
                        onChange: () => (_ctx.isRoute ? _ctx.onOpenRoute() : _ctx.changeRoute(true)),
                        isActive: _ctx.isRoute
                      }, null, 8, ["onChange", "isActive"]),
                      _createVNode("div", _hoisted_22, " Route " + _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 1)
                    ])
                  ]),
                  _createVNode(_component_RouteOptionsSection, { isEdit: "" })
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.isRoute ? 'bg-green-lp-300' : 'bg-red-lp-600'
                  } ${_ctx.isRoute ? 'text-green-lp-200' : 'text-red-lp-500'}`
                
                        }, [
                          _createVNode("span", _hoisted_28, _toDisplayString(_ctx.isRoute ? "Active" : "Inactive"), 1)
                        ], 2)
                      ])
                    ], 512), [
                      [_vShow, !_ctx.isError]
                    ])
                  ]),
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.formatDate(_ctx.detailData.created_at)), 1),
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.detailData.created_by), 1)
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDate(_ctx.detailData.updated_at || _ctx.detailData.created_at)), 1),
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.detailData.updated_by || _ctx.detailData.created_by), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseRoute,
      onSubmit: 
      () =>
        _ctx.isRoute
          ? _ctx.changeRoute(false)
          : _ctx.canActiveRoute
          ? _ctx.changeRoute(true)
          : _ctx.onCloseRoute()
    ,
      title: 
      _ctx.isRoute
        ? 'Non-aktifkan Route Mapping'
        : _ctx.canActiveRoute
        ? 'Aktifkan Route Mapping'
        : 'Opsi Tidak Dapat Diaktifkan'
    ,
      message: 
      _ctx.isRoute
        ? 'Selama Route Mapping berstatus non-aktif maka Route Mapping tidak dapat digunakan'
        : _ctx.canActiveRoute
        ? 'Selama Route Mapping berstatus aktif maka Route Mapping dapat digunakan'
        : 'Mohon cek status data leg, transport atau vendor'
    ,
      image: _ctx.isRoute || _ctx.canActiveRoute ? 'inactive-location' : 'warning',
      textSuccess: 
      _ctx.isRoute ? 'Non-aktifkan' : _ctx.canActiveRoute ? 'Aktifkan' : 'Oke'
    ,
      textCancel: _ctx.isRoute || _ctx.canActiveRoute ? 'Kembali' : '',
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit", "title", "message", "image", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openRoute]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Perubahan Disimpan",
      message: `Route Mapping “${_ctx.detailData.route_name}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Route Mapping",
      message: 
      `Anda yakin akan menyimpan perubahan untuk  Route Mapping “${_ctx.detailData.route_name}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8",
      isLoading: _ctx.isLoading
    }, null, 8, ["onSubmit", "onClose", "message", "isLoading"]), [
      [_vShow, _ctx.openModal]
    ])
  ], 64))
}